<script setup lang="ts">
import { updateColorTokens } from '@/util/colorTokens'
import { Capacitor, registerPlugin } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'
import {
  AppVersionsInstance, // Used in template
  enableAnalytics,
  ForcedAppUpdate, // Used in template
  FullScreenImageViewPlugin,
  ScreenOrientationPlugin,
} from '@ghl/clientportal-core'
import {
  getSessionCookieData,
  isGokollab,
  isPwa,
  sendNotificationToken,
} from '@ghl/clientportal-core/init'
import { UIContentWrap } from '@gohighlevel/ghl-ui' // Used in template
import { useHead } from '@vueuse/head'
import { onMounted } from 'vue'

const WebViewBackgroundPlugin: any = registerPlugin('WebViewBackgroundPlugin')

onMounted(async () => {
  // Initialize theme based on system preference before user data loads
  updateColorTokens()

  if (Capacitor.isNativePlatform()) {
    FullScreenImageViewPlugin.hideFullScreenView()
    if (Capacitor.isPluginAvailable('WebViewBackgroundPlugin')) {
      WebViewBackgroundPlugin.removeBackground()
    }
    await ScreenOrientationPlugin.lockPortraitOrientation()
  }
  if (isPwa()) {
    const cookie = await getSessionCookieData()
    if (!isGokollab()) {
      if (!cookie) {
        window.location.pathname = '/login'
        return false
      }
      // await validatePwaAuth()
    }
  }

  useHead({
    meta: [
      {
        name: 'viewport',
        content: isPwa()
          ? 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
          : 'width=device-width, initial-scale=1.0',
      },
    ],
  })
  if (isGokollab()) {
    enableAnalytics(null)
  }

  // window.addEventListener('push-notification', (event: Event) => {
  //   handleIOSPushRedirection(event)
  // })
  // Add an event listener for the custom event 'push-token'
  window.addEventListener('push-token', (event: Event) => {
    // Do something with the token (e.g., send it to your server)
    const customEvent = event as CustomEvent
    const token = customEvent?.detail
    sendNotificationToken(token)
  })
  if (Capacitor.getPlatform() === 'android') {
    SplashScreen.hide()
  }
})
</script>
<template>
  <metainfo />
  <ForcedAppUpdate v-if="AppVersionsInstance.isForceUpdateRequired" />
  <UIContentWrap
    v-else
    class="outer-container default_font bg-communities-surface !text-communities-font-primary transition-colors duration-300"
    :full-screen="true"
  >
    <!-- <Loading /> -->
    <router-view />
  </UIContentWrap>
</template>
<style scoped>
.hl-wrapper-container {
  padding: 0px !important;
  background-color: var(--surface) !important;
  transition: background-color 0.3s ease;
}
@media (max-width: 930px) {
  .outer-container {
    padding: 0px !important;
  }
}
</style>
